import * as yup from 'yup';

const schema = yup.object().shape({
  cep: yup.string().required('Campo obrigatório').min(8),
  cidade: yup.string().required('Campo obrigatório'),
  estado: yup.string().required('Campo obrigatório'),
});

export default schema;
